import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import { truncate } from '../../util';

class Component extends BaseComponent {
    componentWillMount() {
        this.props.getPsychics();
    }

    render({ psychics }) {
        if (psychics) {
            return (
                <oranum-psychics-responsive>
                    <h3>
                        Online Spiritual Advisors
                        <span>Chat now for up to 10 minutes free!</span>
                    </h3>
                    <row>
                        {psychics.map(psychic => this.renderPsychic(psychic))}
                    </row>
                </oranum-psychics-responsive>
            );
        }

        return <oranum-psychics-responsive />;
    }

    renderPsychic = (psychic) => {
        const last = psychic.likes.lastIndexOf(' ');
        const truncated_likes = psychic.likes.substring(0, last);
        const likes = psychic.likes != truncated_likes ? truncated_likes + '…' : psychic.likes;

        return (
            <column class='is-12-mobile is-6'>
                <a href={psychic.link} target='_blank'>
                    <img src={psychic.thumb} alt={psychic.performerid} />
                    <h4>{psychic.performerid}</h4>
                </a>
                <p>{truncate(likes, 70)}</p>
                <a class='arrow' href={psychic.link} target='_blank'>ENTER MY FREE CHAT ROOM</a>
            </column>
        );
    }
}

const mapStateToProps = (state) => ({
    psychics: state.oranum && state.oranum.psychics,
});

const mapDispatchToProps = (dispatch) => ({
    getPsychics: () => dispatch({ type: 'oranum:get-psychics' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/responsive/oranum-psychics.js